import React, { useState } from 'react'
import { RegisterKonnectDevice } from 'js/Api/index';

const RegisterKonnect = () => {

    const [device_name, setDevice_name] = useState('')
    const [device_id, setDevice_id] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    const [newDevice, setnewDevice] = useState(null)

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        const result = await RegisterKonnectDevice(device_name, device_id);
        if (result.success) {
            setnewDevice(result.data)
        }
        else {
            setError(result.error);
        }

        setIsLoading(false);
    }

    const SetNewRegForm = async (e) => {
        e.preventDefault();
        setDevice_name("");
        setDevice_id("");
        setnewDevice(null);
    }

    return (
        <>
            <div className="midde_cont">
                <div className="container-fluid" style={{ paddingLeft: "0", paddingRight: "0" }} >
                    <div className="row column_title">
                        <div className="col-md-12">
                            <div className="page_title">
                                <h2>Register Konnekt Device</h2>
                            </div>
                        </div>
                    </div>
                    <div class="white_shd full margin_bottom_30" style={{ width: "30%" }}>
                        <div class="full inner_elements">
                            <div class="padding_infor_info">
                                {newDevice != null ?
                                    <div>
                                        <div class="form-group text-center">
                                            <div style={{ fontWeight: '700px', color: 'green', textAlign: 'center' }}>
                                                Your konnekt device is registered successfully.
                                            </div>
                                            <br />
                                        </div>
                                        <div class="form-group">
                                            <strong><label class="col-form-label" >Konnekt Name :</label></strong>{newDevice?.name}
                                        </div>
                                        <div class="form-group">
                                            <strong><label class="col-form-label" >Videophone Profile Name :</label></strong>{newDevice?.konnektDeviceId}
                                        </div>
                                        <div class="form-group">
                                            <strong><label class="col-form-label" >Care Window Device Id :</label></strong>{newDevice?.id}
                                        </div>
                                        <div class="form-group">
                                            <strong><label class="col-form-label" >&nbsp;</label></strong>
                                            <button type="submit" class="btn btn-primary" onClick={SetNewRegForm}>Register New device</button>
                                        </div>
                                        
                                    </div>
                                    :
                                    <div>
                                        <form onSubmit={handleSubmit}>
                                            <div class="form-group">
                                                <label class="col-form-label" >Who will be using this Konnekt device?</label>
                                                <input type="text" class="form-control" id="devicename" required value={device_name} onChange={(e) => setDevice_name(e.target.value)} />
                                            </div>
                                            <div class="form-group">
                                                <label class="col-form-label" >Videophone Profile Name</label>
                                                <input type="text" class="form-control" id="deviceid" required value={device_id} onChange={(e) => setDevice_id(e.target.value)} />
                                            </div>
                                            <div class="form-group text-center">
                                                <label for="staticEmail" class="col-form-label">&nbsp;</label>
                                                <button type="submit" class="btn btn-success" disabled={isLoading}>Register</button>
                                            </div>
                                        </form>
                                        {error && (
                                            <div className="error-message" style={{ fontWeight: '700px', color: 'red', textAlign: 'center' }}>
                                                {error}
                                            </div>
                                        )}
                                        {isLoading && <div>Loading...</div>}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RegisterKonnect;